import VNav from './VNav.vue';

export { VNav };
export default VNav;
